module.exports = __webpack_public_path__ + "img/hjy.f620df70.png";